// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Slider-module__root--rqnYG {
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  padding: 0;
  border: 0;
  margin: 0;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.Slider-module__root--rqnYG::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(
    to right,
    #1a1a1a 0 var(--slider-progress),
    #eee var(--slider-progress) 100%
  );
}

.Slider-module__root--rqnYG::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  border: 0;
  border-radius: 50%;
  margin-top: -6px;
  appearance: none;
  background-color: #1a1a1a;
}

.Slider-module__root--rqnYG::-moz-range-track {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #eee;
}

.Slider-module__root--rqnYG::-moz-range-progress {
  height: 4px;
  border-radius: 2px;
  background-color: #1a1a1a;
}

.Slider-module__root--rqnYG::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: 0;
  border-radius: 50%;
  background-color: #1a1a1a;
}

.Slider-module__root--rqnYG:focus-visible {
  outline: 2px solid #1a1a1a;
  outline-offset: 2px;
}

.Slider-module__root--rqnYG:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Slider/Slider.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".root {\n  box-sizing: border-box;\n  width: 100%;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  margin: 0;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.root::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background: linear-gradient(\n    to right,\n    #1a1a1a 0 var(--slider-progress),\n    #eee var(--slider-progress) 100%\n  );\n}\n\n.root::-webkit-slider-thumb {\n  width: 16px;\n  height: 16px;\n  border: 0;\n  border-radius: 50%;\n  margin-top: -6px;\n  appearance: none;\n  background-color: #1a1a1a;\n}\n\n.root::-moz-range-track {\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background-color: #eee;\n}\n\n.root::-moz-range-progress {\n  height: 4px;\n  border-radius: 2px;\n  background-color: #1a1a1a;\n}\n\n.root::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border: 0;\n  border-radius: 50%;\n  background-color: #1a1a1a;\n}\n\n.root:focus-visible {\n  outline: 2px solid #1a1a1a;\n  outline-offset: 2px;\n}\n\n.root:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Slider-module__root--rqnYG`
};
export default ___CSS_LOADER_EXPORT___;
